/**
 * @deprecated Préférer `import { notify } from '../components/common/AppToast'`
 * Conservé pour compatibilité avec les appels existants.
 */
import { notify, showAppToast } from '../components/common/AppToast';

export function showViewportNotice(message, type = 'warning') {
  showAppToast(message, type === 'error' ? 'error' : type);
}

export { notify, showAppToast };
export default showViewportNotice;
